<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Subcontractor was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Subcontractor - {{ this.subcontractor.name }}</h1>
    <app-audit-line [data]='this.subcontractor'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-subcontractor-form [subcontractor]='this.subcontractor'></app-subcontractor-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/subcontractors'>Cancel</button>
    </form>
  </div>
</div>
